import React, { useState } from "react";
import {
  TitleContainer,
  TitleTextHolder,
  TitleText,
  ButtonContainer,
  SubtitleText,
  PaymentLinkContainer,
  PaymentLinkHeader,
  TitleSearchContainer,
  PaymentLinkTitleText,
  FilterContainer,
  CalendarTextHolder,
  CalendarText,
  CalendarLinkText,
  ButtonSection,
  ButtonSectionUp,
  DoubleButton,
  ExportDataButton,
  ExportIcon,
  HorizontalLine,
  ActiveGangButtonHolder,
  ActiveGangButton,
  NavLinkText,
  ButtonSectionDown,
  PaymentAnalyticsContainer,
  EmptyDashboardContainer,
  ExportButtonandSettingIconPhone,
  ButtonAndSettingsIcon,
  DontShowOnPhone,
} from "./Dashboard.styles";
import Buttons from "../../components/Button/button.component";
import { colors } from "../../theme/color";
import SearchBar from "../../components/SearchBar/SearchBar";
import { LuCalendarDays } from "react-icons/lu";
import { RxDividerVertical } from "react-icons/rx";
import { export_icon } from "../../../public/assets";
import Table from "../../components/Table/Table";
import EmptyDashBoard from "../../components/DashBoardComponents/EmptyDashBoard/index";
import { useNavigate } from "react-router-dom";
import { IoSettingsOutline } from "react-icons/io5";
import PaymentAnalyticsComponent from "../../components/DashBoardComponents/PaymentLink/PaymentAnalytics/index";

const Dashboard = () => {
  const [activeLink, setActiveLink] = useState<number>(1);
  const [activeButton, setActiveButton] = useState<number>(1);
  const navigate = useNavigate();

  const handleLinkClick = (linkNumber: number) => {
    setActiveLink(linkNumber);
  };

  const handleActiveButton = (buttonNumber: number) => {
    setActiveButton(buttonNumber);
  };

  return (
    <>
      <TitleContainer>
        <TitleTextHolder>
          <TitleText>Payment Link</TitleText>
          <SubtitleText>Add new products and create payment link</SubtitleText>
        </TitleTextHolder>
        <ButtonContainer>
          <Buttons
            label="Create Payment Link"
            backgroundColor={colors.ButtonBackgroundColors.primaryDefaultButton}
            borderRadius="10px"
            color={colors.ButtonBackgroundColors.primaryDefaultButton}
            cursor="pointer"
            height="44px"
            width="184px"
            textColor={colors.White}
            handleClick={() => navigate("/dashboard/add-new-product")}
          />
        </ButtonContainer>
      </TitleContainer>
      <PaymentLinkContainer>
        <PaymentLinkHeader>
          <TitleSearchContainer>
            <PaymentLinkTitleText>My Payment Links</PaymentLinkTitleText>{" "}
            <SearchBar
              onSearch={function (searchItem: string): void {
                throw new Error("Function not implemented.");
              }}
            />
          </TitleSearchContainer>{" "}
          <FilterContainer>
            <LuCalendarDays
              color={colors.ButtonBackgroundColors.primaryDefaultButton}
              size={"20px"}
            />
            <CalendarTextHolder>
              <CalendarText>From: </CalendarText>
              <CalendarLinkText>Start Date</CalendarLinkText>
            </CalendarTextHolder>
            <RxDividerVertical color={colors.LIGHT_GRAY} />
            <CalendarTextHolder>
              <CalendarText>To: </CalendarText>
              <CalendarLinkText> End Date</CalendarLinkText>
            </CalendarTextHolder>
          </FilterContainer>
          <ExportButtonandSettingIconPhone>
            <ExportDataButton>
              <ExportIcon src="/assets/icons/export_icon.png" />
              <CalendarText>Export Data</CalendarText>
            </ExportDataButton>
            <IoSettingsOutline fontSize={"20px"} />
          </ExportButtonandSettingIconPhone>
        </PaymentLinkHeader>
        <ButtonSection>
          <ButtonSectionUp>
            <ButtonAndSettingsIcon>
              <DoubleButton>
                <Buttons
                  label="Payment Links"
                  border={"8px"}
                  color={
                    activeButton === 1
                      ? `${colors.ButtonBackgroundColors.primaryDefaultButton}`
                      : "#f7f7f7"
                  }
                  cursor="pointer"
                  height="44px"
                  width="124px"
                  textColor={
                    activeButton === 1
                      ? `${colors.White}`
                      : `${colors.DARK_GRAY}`
                  }
                  handleClick={() => handleActiveButton(1)}
                />
                <Buttons
                  label="Transaction History"
                  color={
                    activeButton === 2
                      ? `${colors.ButtonBackgroundColors.primaryDefaultButton}`
                      : "#f7f7f7"
                  }
                  border={"8px"}
                  cursor="pointer"
                  height="44px"
                  width="184px"
                  textColor={
                    activeButton === 2
                      ? `${colors.White}`
                      : `${colors.DARK_GRAY}`
                  }
                  handleClick={() => handleActiveButton(2)}
                />
              </DoubleButton>
              <DontShowOnPhone>
                <IoSettingsOutline fontSize={"20px"} />
              </DontShowOnPhone>
            </ButtonAndSettingsIcon>
            <DontShowOnPhone>
              <ExportDataButton>
                <ExportIcon src="/assets/icons/export_icon.png" />
                <CalendarText>Export Data</CalendarText>
              </ExportDataButton>
            </DontShowOnPhone>
          </ButtonSectionUp>
          <HorizontalLine />
          <ButtonSectionDown>
            <ActiveGangButtonHolder>
              <ActiveGangButton
                active={activeLink === 1}
                onClick={() => handleLinkClick(1)}
              >
                <NavLinkText active={activeLink === 1}>All</NavLinkText>
              </ActiveGangButton>
              <ActiveGangButton
                active={activeLink === 2}
                onClick={() => handleLinkClick(2)}
              >
                <NavLinkText active={activeLink === 2}>Active</NavLinkText>
              </ActiveGangButton>
              <ActiveGangButton
                active={activeLink === 3}
                onClick={() => handleLinkClick(3)}
              >
                <NavLinkText active={activeLink === 3}>Inactive</NavLinkText>
              </ActiveGangButton>
            </ActiveGangButtonHolder>
          </ButtonSectionDown>
        </ButtonSection>
        <Table />
        <EmptyDashboardContainer>
          <EmptyDashBoard
            titleText="No payment link history"
            subtitleText="All payment link history will be displayed here"
          />
        </EmptyDashboardContainer>
      </PaymentLinkContainer>

      <PaymentAnalyticsContainer>
        <PaymentAnalyticsComponent />
      </PaymentAnalyticsContainer>
    </>
  );
};

export default Dashboard;
